import { render, staticRenderFns } from "./courseworks.vue?vue&type=template&id=d018c9b2&scoped=true"
import script from "./courseworks.vue?vue&type=script&setup=true&lang=ts"
export * from "./courseworks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./courseworks.vue?vue&type=style&index=0&id=d018c9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d018c9b2",
  null
  
)

export default component.exports